import { useTranslate } from "@refinedev/core";
import Textarea from "@uiw/react-md-editor/lib/components/TextArea/Textarea";
import {
  Form,
  Input,
  Row,
  Col,
} from "antd";
import TextArea from "antd/es/input/TextArea";

export const FormList = ({ }: any) => {
  const t = useTranslate();

  return (
    <Row gutter={[64, 0]} wrap>
      <Col xs={24} lg={8}>
        <Form.Item
          label={"Service"}
          name="service"
          rules={[
            {
              required: true,
              message: "Service is required!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Description"}
          name="description"
          rules={[
            {
              required: true,
              message: "Description is required!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"URL"}
          name="url"
          rules={[
            {
              required: true,
              message: "URL is required!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Username"}
          name="username"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Password"}
          name="password"
        >
          <Input type="password" />
        </Form.Item>
        <Form.Item
          label={"Renewal Date"}
          name="renewalDate"
        >
          <Input type="date" />
        </Form.Item>
        <Form.Item
          label={"Billing Info"}
          name="billingInfo"
        >
          <TextArea />
        </Form.Item>
      </Col>
    </Row >
  );
};
